import { SCORECARD_TAGS } from "../common.js";
import { xCardScorecardApi } from "../api.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const xCardTableDataHooks = xCardScorecardApi.injectEndpoints({
  endpoints: (builder) => ({
    getTableData: builder.query({
      query: ({ payload, workspaceId }) => ({
        url: EnvironmentService.callXCardApiCommonInfra() ? `/workspaces/${workspaceId}/table/data` : `/table/data`,
        body: payload,
        method: "POST"
      }),
      providesTags: (result, error, { cacheKey }) => [{ type: SCORECARD_TAGS.XCARD_TABLE, cacheKey }]
    })
  })
});
const { usePrefetch: usexCardTableDataApiPrefetch, useGetTableDataQuery } = xCardTableDataHooks;
export {
  useGetTableDataQuery,
  usexCardTableDataApiPrefetch,
  xCardTableDataHooks
};
//# sourceMappingURL=table.js.map
